import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { BinderSessionWizardService } from '../services/sections/binder/binder-session-wizard.service';
import { Observable, of } from 'rxjs';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { catchError, map } from 'rxjs/operators';
import {BinderSessionStateService} from '../services/binder-session-state.service';

@Injectable({
	providedIn: 'root',
})
export class BinderSessionGuard implements CanActivate {
	constructor(
		private router: Router,
		private binderSessionWizardService: BinderSessionWizardService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		GlobalSettingsService.isGlobalLoaderLoading = true;
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const token = route.paramMap.get('token');

		if (!token) {
			this.router.navigate(['/404']);
			return of(false);
		}

		return this.binderSessionWizardService.confirmStatus(token).pipe(
			map(response => {
				const status = response.binderSessionStatus;

				if (!status.isLive) {
					this.router.navigate([`/${token}/binder-session/status`]);
					return false;
				}

				if (status.isConfirmationRequired && status.isRedirectRequired) {
					this.router.navigate([`/${token}/binder-session/confirmation-required`]);
					return false;
				}
				if (!status.isConfirmationRequired){
					return true;
				}
				if (status.isConfirmationRequired && !status.isRedirectRequired) {
					return true;
				}

				this.router.navigate(['/404']);
				return false;
			}),
			catchError(() => {
				this.router.navigate(['/404']);
				return of(false);
			})
		);
	}
}
